import {useState} from 'react'
import PhoneInput from '@/components/form/PhoneInput'
import EmailInput from '@/components/form/EmailInput'
import composesStyles from '@/styles/_settings/composes.module.css'
import labelStyles from '@/styles/atoms/Label/styles.module.css'
import inputStyles from '@/styles/atoms/Input/styles.module.css'
import logger from '@/lib/logger'
import {onInputFocus} from '@/lib/inputFocus'

const Contact = ({state, onChange, onSubmit, userProfile}) => {
  const [loggerInteraction, setInteraction] = useState({
    name: null,
    phone: null,
    email: null
  })

  function onChangeName(value) {
    onChange({
      ...state,
      name: value
    })
    if (!loggerInteraction.name) {
      setInteraction({
        ...loggerInteraction,
        name: true
      })
      logger.action('seller-onboarding-step-contact-name', {name: value})
    }
  }

  function onChangePhone(value) {
    onChange({
      ...state,
      phone: value
    })
    if (!loggerInteraction.phone) {
      setInteraction({
        ...loggerInteraction,
        phone: true
      })
      logger.action('seller-onboarding-step-contact-phone', {phone: value})
    }
  }

  function onChangeEmail(value) {
    onChange({
      ...state,
      email: value
    })
    if (!loggerInteraction.email) {
      setInteraction({
        ...loggerInteraction,
        email: true
      })
      logger.action('seller-onboarding-step-contact-email', {email: value})
    }
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (onSubmit) {
      onSubmit()
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className={`${composesStyles.animation_enterfrombottom} ${composesStyles.paddingx} ${composesStyles.fullmaxwidth}`}
    >
      {state && (
        <>
          <p className={labelStyles.ecLabel_formItem}>
            Precisamos de algumas informações de contato para criar o seu
            cadastro
          </p>
          <div
            className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
          >
            <span className={labelStyles.ecLabel__value}>Nome</span>
            <input
              name="name"
              type="text"
              tabIndex="0"
              className={inputStyles.ecInput}
              value={state.name}
              onChange={({currentTarget: {value}}) => onChangeName(value)}
              onFocus={(e) => onInputFocus(e.target.offsetTop)}
            />
          </div>
          <div
            className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
          >
            <span className={labelStyles.ecLabel__value}>Telefone </span>
            <PhoneInput
              name="phone"
              type="tel"
              tabIndex="0"
              readOnly={userProfile && userProfile.phone ? true : false}
              value={state.phone || undefined}
              onChange={onChangePhone}
              onFocus={(e) => onInputFocus(e.target.offsetTop)}
            />
          </div>
          <div className={labelStyles.ecLabel}>
            <span className={labelStyles.ecLabel__value}>E-mail</span>
            <EmailInput
              name="email"
              type="email"
              tabIndex="0"
              placeholder="Ex: nome@email.com"
              value={state.email || undefined}
              onChange={({currentTarget: {value}}) => onChangeEmail(value)}
              onFocus={(e) => onInputFocus(e.target.offsetTop)}
            />
          </div>
        </>
      )}
      <button className={composesStyles.formhiddenbutton} type="submit">
        enviar
      </button>
    </form>
  )
}

export default Contact
